import React from "react";

function MainTitle(props) {
  return (
    
      <h1 className="mainTitle"><a href="/">The Turin Times</a></h1>
    
  );
}

export default MainTitle;